// Library imports.
import axios, { AxiosResponse } from "axios";
import axiosInstance from './axiosInstance';

// App imports.
import { config } from "./config";

export interface IUserInfo {
  granteeId: number
  , granteeName?: string
  , loggedIn: boolean
  , regionId?: number
  , tribeId?: number
  , viewAll: boolean
}
export interface IGrantee {
  granteeId: number
  , granteeName: string
  , granteeAbbreviation: string
  , regionId?: number
}
export interface IRegion {
  regionId: number
  , regionName: string
}
export interface IFiscalYear {
  fiscalYear: number
  , final?: boolean
}
export interface IDbSelectListItem {
  value: string
  , text: string
}

export interface IGranteePortalSearchParams {
  incomeCutoff: string
  , intake: string
  , weatherizationPercent: string
  , states: string[]
  , includeBenefitMatrix: boolean
  , includeAssurance16: boolean
  , includeBenefitLevels: boolean
  , includeCriteriaForVarying: boolean
  , includeContact: boolean
  , includeGranteeProfiles: boolean
  , includeCooling: boolean
  , includeCrisis: boolean
  , includeWzDescription: boolean
  , includeOutreach: boolean
  , includeHousing: boolean
  , includeBenefitTargetingIndex: boolean
  , includeBurdenReductionIndex: boolean
  , includeCategoricalEligibility: boolean
  , includeNominalBenefits: boolean
  , includeIncomeThreshold: boolean
  , includePercentageWeatherization: boolean
  , includeIntakeOrganizationType: boolean
  , hasCategoricalEligibility: string
  , hasCoolingProgram: string
  , crisisPeriod: string
  , runsAssurance16: boolean
  , programFundingLevel: boolean
  , fuelType: boolean
  , eaProgram: boolean
  , climateZone: boolean
  , itSystemType: boolean
  , selectedIndexValOperator: string
  , enteredIndexVal: number
  , enteredIndexValUpperBound: number
}
export interface IGranteePortalResults {
  reportData: any[],
  columnHeaders: any[],
  columnNames: any[]
}

export class baseWorker {
  public static currencyRound(inCurrency): number {
    return Math.round((inCurrency + Number.EPSILON) * 100) / 100;
  }
  public booleanToNullOrFlag(inBool): string {
    if (inBool === true) {
      return "Y";
    }
    else if (inBool === false) {
      return "N";
    }
    else {
      return null;
    }
  }
  public nullOrStringToString(inString): string {
    if (inString == null) {
      return '';
    }
    else {
      return inString;
    }
  }
  public flagToNullOrBoolean(inFlag): boolean {
    if (inFlag === "Y") {
      return true;
    }
    else if (inFlag === "N") {
      return false;
    }
    else {
      return null;
    }
  }
  public nullOrNumberToNumber(inNumber): number {
    if (inNumber == null) {
      return null;
    }
    if (isNaN(inNumber)) {
      return null;
    }
    else {
      return Number(inNumber);
    }
  }
  public handleError(error): Promise<any> {
    console.log(error);

    if (error.response && error.response.data) {
      if (error.response.data.message) {
        return Promise.reject(new Error(error.response.data.message));
      }
      else {
        return Promise.reject(new Error(error.response.data));
      }
      
    } else if (error.request) {
      return Promise.reject(new Error("Failed to connect to server."));
    } else {
      return Promise.reject(error);
    }
  }

  //get basic userinfo for logged in drupal user
  public async getUserInfo(): Promise<IUserInfo> {

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/search/user`);

    const userInfoReturned: IUserInfo = {
      granteeId: response.data.granteeId,
      tribeId: response.data.tribeId,
      viewAll: response.data.viewAll,
      loggedIn: response.data.loggedIn,
      regionId: response.data.regionId,
    };
    return userInfoReturned;
  }
  public async getGrantees(): Promise<IGrantee[]> {
    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/search/grantees`);               
    const granteesReturned: IGrantee[] = [];
    response.data.forEach(function (granteeDatabaseRow) {
      const grantee: IGrantee = {
        granteeName: granteeDatabaseRow.GRAN_NAME,
        granteeId: granteeDatabaseRow.GRAN_ID,
        regionId: granteeDatabaseRow.REGN_ID,
        granteeAbbreviation: granteeDatabaseRow.GRAN_ABBR,
      };
      granteesReturned.push(grantee);
    });
    return granteesReturned;
  }
  public async getRegions(): Promise<IRegion[]> {
    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/search/regions`);               
    const granteesReturned: IRegion[] = [];
    response.data.forEach(function (regRow) {
      const region: IRegion = {
        regionId: regRow.REGN_ID,
        regionName: regRow.REGN_DESC,
      };
      granteesReturned.push(region);
    });
    return granteesReturned;
  }
  public async getSedsYears(): Promise<IFiscalYear[]> {

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/datareliability/sedsyears`);               

    const sedsYearsReturned: IFiscalYear[] = [];
    response.data.forEach(function (sedsYearDatabaseRow) {
      const year: IFiscalYear = {
        fiscalYear: sedsYearDatabaseRow.FISCAL_YEAR,
      };
      sedsYearsReturned.push(year);
    });

    return sedsYearsReturned;
  }
  public async getFiscalYears(): Promise<IFiscalYear[]> {

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/search/years`);

    const fiscalYearsReturned: IFiscalYear[] = [];
    response.data.forEach(fiscalYearDatabaseRow => {
      const year: IFiscalYear = {
        fiscalYear: fiscalYearDatabaseRow.YEAR,
        final: fiscalYearDatabaseRow.FINAL_FLAG === 'Y'
      };
      fiscalYearsReturned.push(year);
    });

    return fiscalYearsReturned;
  }
  public async getDbSelectListItems(selectListCode: string): Promise<IDbSelectListItem[]> {

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.get(`${config.apiBaseURL}/pmi/selectlistitems/${selectListCode}`); 

    const dbSelectListItems: IDbSelectListItem[] = [];
    response.data.map(i =>
      dbSelectListItems.push({
        value: i.VALUE,
        text: i.TEXT
      })
    );

    return dbSelectListItems;
  }

  //get grantee search portal data
  public async getGranteeSearchPortalData(inParams: IGranteePortalSearchParams): Promise<IGranteePortalResults> {
    //pass parameter in FormData object because Php expects form encoded POST
    const formData = new FormData();
    //iterate inParams adding each property to formData
    for (const [key, value] of Object.entries(inParams)) {
      if (Array.isArray(value)) {
        value.forEach((v) => {
          formData.append(key + '[]', v);
        });
      }
      else {
        formData.append(key, value);
      }
    }

    
    const response: AxiosResponse =
      //using the apiBaseURL property defined in config.ts which we import above
      await axiosInstance.post(`${config.apiBaseURL}/stateslikeme/report`, formData);//
    const results: IGranteePortalResults = {
      reportData: response.data[0],
      columnHeaders: response.data[1],
      columnNames: response.data[2]
    };
    return results;
  }
}

